// Salepify app - show modal one every 1.5 minutes
//  document.addEventListener('DOMContentLoaded', function () {

//   if (window.location.pathname === '/cart') {
//     // console.log("skippy skipped");
//     localStorage.removeItem('salepifyLastShown');
//     return;
//   }
   
//   const cartMoneyEl = document.querySelector('.c-cart-drawer__subtotal .is-money');

//   if (cartMoneyEl) {
//     const rawText = cartMoneyEl.textContent.trim();
//     const numericValue = parseFloat(rawText.replace(/[^0-9.]/g, ''));
//     // console.log("numericValue " + cartMoneyEl)

//     if (!isNaN(numericValue) && numericValue > 0) {
//       // console.log('Cart value is more than 0:', numericValue);
//       (function () {
//         const popupClass = 'salepify-popup-wrapper';
//         const popup = document.querySelector(`.${popupClass}`);
//         const lastShownKey = 'salepifyLastShown';
//         const now = Date.now();
//         const lastShown = parseInt(localStorage.getItem(lastShownKey), 10);
      
//         // Make sure the popup is hidden by default
//         if (popup) popup.style.display = 'none';
      
//         if (isNaN(lastShown)) {
          
//           // First visit: store timestamp and show popup
//           localStorage.setItem(lastShownKey, now);
//           if (popup) popup.style.display = 'flex';
//           // console.log("now " + now)
//           // console.log("whats in LS " + lastShown)
          
//         } else {
          
//           const timeSinceLastShown = now - lastShown;
//           // console.log("now " + now)
//           // console.log("whats in LS " + lastShown)
//           // console.log("time diff " + timeSinceLastShown)
          
//           if (timeSinceLastShown >= 120000) {
//             // It's been more than a one and half minute → update timestamp & show
//             localStorage.setItem(lastShownKey, now);
//             if (popup) popup.style.display = 'flex';
//           }
          
//           // else: less than 1 min passed → do nothing
//         }
//       })();
//     }
//     else{
//        localStorage.removeItem(lastShownKey);
//       // console.log('Cart is empty – localStorage key cleared');
//     }
//   }
// });


// GSC Countdown Timer Bar app - exclude bar show 
document.addEventListener("DOMContentLoaded", function () {
  var smallTimer = document.querySelector(".gta-block__root");
  var barTimer = document.querySelector(".gta-widget.gta-bar.GSC-BAR-cWzgOWLiJLXl");

  if (smallTimer && barTimer) {
    barTimer.remove();
  }
});



// // Keep checking until the widget checkbox exists
// const precheckInterval = setInterval(() => {
//   const checkbox = document.getElementById("sam_switch_btn");
  
//   if (checkbox) {
//     // Stop checking once found
//     clearInterval(precheckInterval);

//     // If not already checked, tick and trigger the app logic
//     if (!checkbox.checked) {
//       checkbox.checked = true;
//       if (typeof __SAM !== "undefined" && __SAM.widget?.toggleShippingProtection) {
//         __SAM.widget.toggleShippingProtection(checkbox);
//       }
//     }
//   // }
// }, 200); 




// Change image
// document.addEventListener('change', (e) => {
//   if (e.target.matches('select[name="id"]')) {
//     console.log('Changed to:', e.target.value);
//   }
// });